import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/lang/messages'
import dateTimeFormats from '@/lang/dateTimeFormats'
import numberFormats from '@/lang/numberFormats'
Vue.use(VueI18n)

let userLanguage = navigator.language
let locale = userLanguage.split('-')[0]
if (locale !== 'fr' && locale !== 'en') locale = 'en' // en by default

export default new VueI18n({
  locale: locale,
  fallbackLocale: 'fr',
  silentFallbackWarn: true,
  messages,
  dateTimeFormats,
  numberFormats
})
